import React from 'react';
import { motion as m } from 'framer-motion';
import { staggerContainer, fadeIn } from '../variants';

const Copyright = () => {
  return (
  <div className='border-t mt-3 border-accent'>
    <m.div 
    variants={staggerContainer}
    initial='hidden'
    whileInView={'show'}
    viewport={{once: false, amount: 0.2}}
    className='container mx-auto'>
      <div className='flex justify-center'>
      <m.small variants={fadeIn('down', 'tween', 0.3, 1.1)} className='text-accent text-base font-semibold text-center pt-2'>
        © 2023 | All rights reserved | Designed by 
        <a className='text-white font-extrabold hover:text-red-600 transition duration-500' target='_blank' href="https://vlochana-portfolio.netlify.app/">
          Vidura Lochana</a> With <span>❤️</span></m.small>
      </div>
    </m.div>
  </div>
  );
};

export default Copyright;
